import { I_GroupedObservationDataResponse } from '../api/grouped-observation-data.response';
import { ValueTimeResponse } from '../api/value-time.response';
import { ValueTime } from './value-time.model';

/**
 * Dato individual de cada observacion agrupadad
 */
export class C_GroupedObservationData {
  /**
   * Nombre de la observación
   */
  name?: string;
  /**
   * Valor que existirá en caso de haber solicitado First en el campo result
   */
  first?: ValueTime;
  /**
   * Valor que existirá en caso de haber solicitado Last en el campo result
   */
  last?: ValueTime;
  /**
   * Valor que existirá en caso de haber solicitado LastFilled en el campo result
   */
  lastFilled?: ValueTime;
  /**
   * Valor que existirá en caso de haber solicitado Max en el campo result
   */
  max?: ValueTime;
  /**
   * Valor que existirá en caso de haber solicitado Min en el campo result
   */
  min?: ValueTime;
  /**
   * Valor que existirá en caso de haber solicitado Average en el campo result
   */
  average?: ValueTime;
  /**
   * Valor que existirá en caso de haber solicitado Count en el campo result
   */
  count?: ValueTime;
  /**
   * Valor que existirá en caso de haber solicitado Sum en el campo result
   */
  sum?: ValueTime;
  /**
   * Fecha en la que se asigna el valor
   */
  time?: Date;
  /**
   * Valor numérico del turno al que pertenece en caso de haber solicitado Shift en el campo regularity
   */
  shift?: number;
  /**
   * Fecha en la que se asigna el valor del turno al que pertenece en caso de haber solicitado Shift en el campo regularity
   */
  shiftDate?: Date;
  isFilled?: boolean;
  units?: string;
  constructor(json: I_GroupedObservationDataResponse) {
    if (!json) return;
    this.initializeFromJson(json);
  }

  initializeFromJson(json: I_GroupedObservationDataResponse) {
    this.name = json.name;
    this.units = json.units;
    this.shift = json.shift;
    this.isFilled = json.isFilled;
    const mapVT = (data?: ValueTimeResponse) => data ? new ValueTime(data) : undefined;
    this.first = mapVT(json.first);
    this.last = mapVT(json.last);
    this.lastFilled = mapVT(json.lastFilled);
    this.max = mapVT(json.max);
    this.min = mapVT(json.min);
    this.average = mapVT(json.average);
    this.count = mapVT(json.count);
    this.sum = mapVT(json.sum);
    if (json.time) this.time = new Date(json.time);
    if (json.shiftDate) this.shiftDate = new Date(json.shiftDate);
  }
}